import { Identifier } from '../models/storage.model';

export function getAccessToken(): string | null {
  return localStorage.getItem(Identifier.TYPE_TOKEN);
}
